import React from 'react';
import PropTypes from 'prop-types';

import { SideBySide } from './side-by-side';

function HeadingWithText({ bgColorClass, children, heading, reverse }) {
  return (
    <SideBySide
      bgColorClass={bgColorClass}
      reverse={reverse}
      slot1={heading}
      slot2={children}
    />
  );
}

HeadingWithText.propTypes = {
  bgColorClass: PropTypes.string,
  children: PropTypes.node,
  heading: PropTypes.node,
  reverse: PropTypes.bool,
};

export { HeadingWithText };
